import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse, X4UnitUpdateModel} from '../../../../domain';
import {HttpPromiseState, SaveStateHolder, StringControl, validators} from '../../../../lib/helpers';

export class AddUnitStore implements SaveStateHolder {
  name: StringControl;
  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly levelId: number) {
    makeObservable(this);
    this.name = new StringControl('name', '', validators.required);
    this.save = null;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    this.name.markTouched();
    if (this.name.invalid)
      return;
    const model: X4UnitUpdateModel = {
      LevelId: this.levelId,
      Name: this.name.value
    };

    this.save = contentLoaders.x4unit.insert(model);
  }
}
